module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_angle_right-3143b39e8f3d93653a863c7bd3324d67.svg";